import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import CKEditor from "react-ckeditor-component";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import {
  get_static_page_list,
  add_static_page
} from "../../../redux/actions/termsPolicyAndContactActions";
import loader from "../../../style/loader/loader.scss";
import "../../../style/manageTermsPolicyAndContact.scss";
import {aclUtil} from "../../util"

const history = createHashHistory();
let xCoordinate = {},
    yCoordinate = {};
class manageTermsPolicyAndContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'PAGE_TEMPLATE',
      path: ["Home","Manage Static Pages"],
      links: ["home",'manageTermsPolicies'],
      msgType: "",
      alertMessage: "",
      show: "",
      termsAndCondition: "",
      privacyPolicy: "",
      contactUs: "",
      termsAndConditionError: "",
      privacyPolicyError: "",
      aboutUs: "",
      aboutUsError: "",
      contactUsError: "",
      becomeAPartner: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.validate = this.validate.bind(this);
    this.handleTermsAndCondition = this.handleTermsAndCondition.bind(this);
    this.handlePrivacyPolicy = this.handlePrivacyPolicy.bind(this);
    this.handleContactUs = this.handleContactUs.bind(this);
    this.handleAboutUs = this.handleAboutUs.bind(this);
    this.handleBecomePartner = this.handleBecomePartner.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleTermsAndCondition(evt) {
    if (this.state.termsAndConditionError !== "") {
      this.setState({ termsAndConditionError: "" });
    }
    var newContent = evt.editor.getData();
    this.setState({
      termsAndCondition: newContent
    });
  }
  handlePrivacyPolicy(evt) {
    if (this.state.privacyPolicyError !== "") {
      this.setState({ privacyPolicyError: "" });
    }
    var newContent = evt.editor.getData();
    this.setState({
      privacyPolicy: newContent
    });
  }
  handleContactUs(evt) {
    if (this.state.contactUsError !== "") {
      this.setState({ contactUsError: "" });
    }
    var newContent = evt.editor.getData();
    this.setState({
      contactUs: newContent
    });
  }
  handleAboutUs(evt) {
    if (this.state.aboutUsError !== "") {
      this.setState({ aboutUsError: "" });
    }
    var newContent = evt.editor.getData();
    this.setState({
      aboutUs: newContent
    });
  }

  handleBecomePartner(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      becomeAPartner: newContent
    });
  }

  validate = () => {
    xCoordinate = {}
    yCoordinate = {}
    let isError = false;
    const errors = {};
    if (this.state.privacyPolicy.length === 0) {
      isError = true;
      this.setState({ privacyPolicyError: "red" });
      if(xCoordinate.key !== 'privacyPolicy'){
        let x = window.scrollX + document.querySelector('#privacyPolicy').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#privacyPolicy').getBoundingClientRect().top - 89
        xCoordinate['privacyPolicy'] = x;
        yCoordinate['privacyPolicy'] = y;
      }
    }
    if (this.state.termsAndCondition.length === 0) {
      isError = true;
      this.setState({ termsAndConditionError: "red" });
      if(xCoordinate.key !== 'termsAndCondition'){
        let x = window.scrollX + document.querySelector('#termsAndCondition').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#termsAndCondition').getBoundingClientRect().top - 89
        xCoordinate['termsAndCondition'] = x;
        yCoordinate['termsAndCondition'] = y;
      }
    }
    if (this.state.aboutUs.length === 0) {
      isError = true;
      this.setState({ aboutUsError: "red" });
      if(xCoordinate.key !== 'aboutUs'){
        let x = window.scrollX + document.querySelector('#aboutUs').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#aboutUs').getBoundingClientRect().top - 89
        xCoordinate['aboutUs'] = x;
        yCoordinate['aboutUs'] = y;
      }
    }
    if (this.state.contactUs.length === 0) {
      isError = true;
      this.setState({ contactUsError: "red" });
      if(xCoordinate.key !== 'contactUs'){
        let x = window.scrollX + document.querySelector('#contactUs').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#contactUs').getBoundingClientRect().top - 89
        xCoordinate['contactUs'] = x;
        yCoordinate['contactUs'] = y;
      }
    }
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    this.setState({ show: true });
    if (!err) {
      const addData = {
        termsAndCondition: this.state.termsAndCondition,
        privacyPolicy: this.state.privacyPolicy,
        contactUs: this.state.contactUs,
        aboutUs: this.state.aboutUs,
        becomeAPartner: this.state.becomeAPartner,
      };
      this.props.add_static_page(addData);
    }
    else{
      let arr = Object.values(yCoordinate)
      let min = Math.min(...arr);
      let yCoordinateKey= '',yCoordinateValue, xCoordinateValue
      {Object.keys(yCoordinate).map((key) => {
        if(yCoordinate[key] === min && yCoordinateKey.length == 0){
          yCoordinateValue = yCoordinate[key]
          yCoordinateKey = key
        }
      })}
      if(yCoordinateKey.length > 0){
        xCoordinateValue = xCoordinate[yCoordinateKey]
        window.scrollTo(xCoordinateValue,yCoordinateValue)
      }
    }
  }

  componentWillMount() {
    this.props.get_static_page_list();
  }
  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }
    if (
      this.props.staticPageList !== nextProps.staticPageList &&
      !isEmpty(nextProps.staticPageList)
    ) {
      let privacyPolicyConst,
        aboutUsConst,
        termsAndConditionConst,
        contactUsConst,
        becomeAPartner;
      nextProps.staticPageList.map((staticPage, index) => {
        privacyPolicyConst = staticPage.privacyPolicy;
        termsAndConditionConst = staticPage.termsAndCondition;
        contactUsConst = staticPage.contactUs;
        aboutUsConst = staticPage.aboutUs;
        becomeAPartner = staticPage.becomeAPartner;
      });
      this.setState({
        aboutUs: aboutUsConst,
        termsAndCondition: termsAndConditionConst,
        privacyPolicy: privacyPolicyConst,
        contactUs: contactUsConst,
        becomeAPartner: becomeAPartner,
      });
    }
    if (this.props.addedStaticPage !== nextProps.addedStaticPage) {
      this.props.clearAlert();
      this.handleShow();
      if (nextProps.addedStaticPage.message) {
        this.props.renderAlert("success", nextProps.addedStaticPage.message);
      }
      this.props.get_static_page_list();
      window.scrollTo(0, 0);
    }
    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({ alertMessage: nextProps.message });
      window.scrollTo(0, 0);
    }
    if (this.props.alertType !== nextProps.alertType) {
      this.handleShow();
      this.setState({ msgType: nextProps.alertType });
      window.scrollTo(0, 0);
    }
    if (this.props.error !== nextProps.error && nextProps.error.length > 0) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);

      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div className="col-lg-12 static-pages">
        {this.props.receivingDetails === true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div>
          <div className="row">
            {this.state.show &&
              this.state.alertMessage !== "" &&
              this.state.msgType && (
                <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Manage Static Pages</header>
            <div className="panel-body">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <form onSubmit={this.handleSubmit}>
                    <Col md={8} xs={12} mdOffset={2}>
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Privacy
                            Policy
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row id="privacyPolicy">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.privacyPolicyError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.privacyPolicy}
                            events={{
                              change: this.handlePrivacyPolicy
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Terms And
                            Condition
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row id="termsAndCondition">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.termsAndConditionError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.termsAndCondition}
                            events={{
                              change: this.handleTermsAndCondition
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Contact Us
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row id="contactUs">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.contactUsError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.contactUs}
                            events={{
                              change: this.handleContactUs
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>About Us
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row id="aboutUs">
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.aboutUsError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.aboutUs}
                            events={{
                              change: this.handleAboutUs
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} xs={12}>
                          <hr />
                        </Col>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            Become A Partner
                          </ControlLabel>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} xs={12}>
                          <CKEditor
                            activeClass={
                              this.state.aboutUsError === ""
                                ? "p10 initial-border"
                                : "p10 border-on-error"
                            }
                            content={this.state.becomeAPartner}
                            events={{
                              change: this.handleBecomePartner
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Row>
                      <Col md={12} xs={12}>
                        <div style={{ color: "red" }}>* field are required</div>
                      </Col>
                    </Row>
                    <Row className="BtnRow">
                      <Col md={12} xs={12}>
                        <Button
                          bsStyle="info"
                          type="submit"
                          id="save-button"
                          disabled={this.props.sending}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

manageTermsPolicyAndContact.propTypes = {
  get_static_page_list: PropTypes.func.isRequired,
  add_static_page: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  staticPageList: state.termsPolicyAndContactReducer.staticPageList,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  error: state.termsPolicyAndContactReducer.error,
  addedStaticPage: state.termsPolicyAndContactReducer.addedStaticPage,
  sending: state.termsPolicyAndContactReducer.sending,
  receivingDetails: state.termsPolicyAndContactReducer.receivingDetails
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    get_static_page_list,
    add_static_page,
    clearAlert,
    renderAlert
  })
)(manageTermsPolicyAndContact);



// WEBPACK FOOTER //
// ./src/app/views/admin/manageTermsPolicies/manageTermsPolicyAndContact.js